/**
 * @fileoverview AppConfig
 *
 */
'use strict';
// Util Import
import * as ConstUtil from './util/ConstUtil';

/**
 * 設定<br>
 *
 * <ul>
 * <li>ログ 表示設定
 * <li>ログ 保存設定
 * <li>接続先
 * </ul>
 * @name AppConfig
 */
const AppConfig = {
  // ログ
  log: {
    // コンソール表示設定
    console: {
      enable: false,
      level: ConstUtil.Common.LOG_LEVEL.debug
    },
    // ログ保存設定
    record: {
      enable: false,
      level: ConstUtil.Common.LOG_LEVEL.debug
    }
  },
  // デバッグ
  isDebug: true,
  // 接続先
  // accessPoint: 'http://localhost:5000',
  accessPoint: 'http://localhost:3002',
  // APIポート番号
  apiPortNumber: '',
  // APPポート番号
  appPortNumber: '',
  // バージョン情報
  versionInformation: {
    api: '/api/2.0',
    version: 'localDebug',
    revision: ''
  },
  // HTTPスキーマ
  httpScheme: 'http://'
};

export default AppConfig;



// WEBPACK FOOTER //
// ./src/js/AppConfig.jsx